import { render, staticRenderFns } from "./ResourceList.vue?vue&type=template&id=3a522564&"
import script from "./ResourceList.vue?vue&type=script&setup=true&lang=js&"
export * from "./ResourceList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports